import * as DataBinning from "../classificators/dataBinning/index.js";
import StrikeZoneModelBase from "../classificators/strikeZoneModel/StrikeZoneModelBase.js";

const getDataBinningForStrikeZone = function(
    strikeZoneModel, binsPerWidth, binsPerHeight,
    { minX, maxX, minY, maxY } = {},
    { classForDataBinningX, classForDataBinningY, classForDataBinning2D } = {},
) {
    if (!(strikeZoneModel instanceof StrikeZoneModelBase)) {
        throw new TypeError('strikeZoneModel must inherit from StrikeZoneModelBase class');
    }

    if (typeof(binsPerWidth) !== 'number') {
        throw new TypeError('binsPerWidth must be an number');
    }

    if (binsPerWidth <= 0) {
        throw new Error('binsPerWidth must be greater than zero');
    }

    if (typeof(binsPerHeight) !== 'number') {
        throw new TypeError('binsPerHeight must be an number');
    }

    if (binsPerHeight <= 0) {
        throw new Error('binsPerHeight must be greater than zero');
    }

    if (typeof(classForDataBinningX) === 'undefined') {
        classForDataBinningX = DataBinning.DataBinning;
    }
    else if (typeof(classForDataBinningX) !== 'function') {
        throw new TypeError('classForDataBinningX must be an class');
    }
    else if (!(new classForDataBinningX(1) instanceof DataBinning.DataBinning)) {
        throw new TypeError('classForDataBinningX must inherit from DataBinning class');
    }

    if (typeof(classForDataBinningY) === 'undefined') {
        classForDataBinningY = DataBinning.DataBinning;
    }
    else if (typeof(classForDataBinningY) !== 'function') {
        throw new TypeError('classForDataBinningY must be an class');
    }
    else if (!(new classForDataBinningY(1) instanceof DataBinning.DataBinning)) {
        throw new TypeError('classForDataBinningY must inherit from DataBinning class');
    }

    if (typeof(classForDataBinning2D) === 'undefined') {
        classForDataBinning2D = DataBinning.DataBinning2D;
    }
    else if (typeof(classForDataBinning2D) !== 'function') {
        throw new TypeError('classForDataBinning2D must be an class');
    }
    else if (!(new classForDataBinning2D(new classForDataBinningX(1), new classForDataBinningY(1)) instanceof DataBinning.DataBinning2D)) {
        throw new TypeError('classForDataBinning2D must inherit from DataBinning2D class');
    }

    const binWidth = (
        strikeZoneModel.getStrikeZoneRight() - strikeZoneModel.getStrikeZoneLeft()
    ) / binsPerWidth;

    const binHeight = (
        strikeZoneModel.getStrikeZoneTop() - strikeZoneModel.getStrikeZoneBottom()
    ) / binsPerHeight;

    return new classForDataBinning2D(
        new classForDataBinningX(binWidth, minX, maxX), 
        new classForDataBinningY(binHeight, minY, maxY)
    );
};

export default getDataBinningForStrikeZone;